import { DEFAULT_CACHE_TIME, DEFAULT_STALE_TIME } from '@web/constants';

export const NEWSFEED_ARTICLE_CACHE_TIME = DEFAULT_CACHE_TIME;
export const NEWSFEED_PAGE_CACHE_TIME = DEFAULT_CACHE_TIME;
export const NEWSFEED_ARTICLE_SEARCH_CACHE_TIME = 1000 * 60 * 5; // 5 min

export const NEWSFEED_ARTICLE_STALE_TIME = DEFAULT_STALE_TIME;
export const NEWSFEED_PAGE_STALE_TIME = DEFAULT_STALE_TIME;
